let mobileMenuInstance = null;

function safeMoveFocusOutOf($container, $fallback) {
    if (!$container || !$container.length) return;

    if ($container.has(document.activeElement).length) {
        if (
            $fallback &&
            $fallback.length &&
            $fallback[0] &&
            typeof $fallback[0].focus === 'function'
        ) {
            $fallback[0].focus();
        } else if (
            document.activeElement &&
            typeof document.activeElement.blur === 'function'
        ) {
            document.activeElement.blur();
        }
    }
}

function MobileNav() {
    this.curItem = null;
    this.curLevel = 0;
    this.backLevel = 0;

    const defaults = {
        initElem: '.navigation',
        menuTitle: 'Menu',
        breakpoint: 1125
    };

    const initElem = ($(defaults.initElem).length) ? $(defaults.initElem) : false;

    if (!initElem) {
        console.log(defaults.initElem + ' element doesn\'t exist, menu not initialized.');
        return;
    }

    defaults.initElem = initElem;

    this.reset = function () {
        this.curItem = null;
        this.curLevel = 0;
        this.backLevel = 0;

        defaults.initElem.find('.navigation__item--has-dropdown')
            .removeClass('nav-dropdown-open nav-dropdown-active')
            .removeData('activated');

        defaults.initElem.find('.navigation__item--block-hidden')
            .removeClass('navigation__item--block-hidden');

        defaults.initElem.children('ul').css({
            transform: 'translateX(0%)'
        });

        $('.utility-block').css({
            transform: 'translateX(0%)'
        });

        $('.inner-right__search-box').css({
            transform: 'translateX(0%)'
        });

        $('.nav-toggle').css({
            transform: 'translateX(0%)'
        });

        defaults.initElem.find('.navigation__item--first-level').css('height', '');
        defaults.initElem.find('.nav-toggle').removeClass('back-visible');
        defaults.initElem.removeClass('navigation--upper-level');
        $('.nav-title').text(defaults.menuTitle);
    };

    _clickHandlers(this);
    _updateMenuTitle(this);

    function _getSubMenu($item) {
        return $item.children('ul').first();
    }

    function _getFirstLevelItem($item) {
        if ($item.hasClass('navigation__item--first-level')) {
            return $item;
        }

        return $item.closest('.navigation__item--first-level');
    }

    function _collapseItem($item, $fallback) {
        if (!$item || !$item.length) return;

        const $subMenu = _getSubMenu($item);

        safeMoveFocusOutOf($subMenu.length ? $subMenu : $item, $fallback);

        $item.removeClass('nav-dropdown-open nav-dropdown-active')
            .removeData('activated');

        const $firstLevel = _getFirstLevelItem($item);

        if ($firstLevel.length) {
            $firstLevel.css('height', '');
        }
    }

    function _collapseSiblingItems($item, $fallback) {
        $item
            .siblings('.navigation__item--has-dropdown')
            .each(function () {
                _collapseItem($(this), $fallback);
            });
    }

    function _clickHandlers(menu) {
        if ($(window).width() >= defaults.breakpoint) {
            return;
        }

        defaults.initElem.off('.mobileNav');

        defaults.initElem.on(
            'click.mobileNav',
            '.navigation__item--has-dropdown > .navigation__link',
            function (e) {
                const $link = $(this);
                const $item = $link.parent();
                const $subMenu = _getSubMenu($item);

                if (!$subMenu.length) {
                    return;
                }

                const isActivated = $item.data('activated') === true;

                if (!isActivated) {
                    e.preventDefault();
                    e.stopImmediatePropagation();

                    _collapseSiblingItems($item, $link);

                    $item.data('activated', true);
                    menu.curItem = $item;

                    _updateActiveMenu(menu);

                    const $firstLevel = _getFirstLevelItem($item);
                    const subMenuHeight = $subMenu.outerHeight();

                    const subMenu2 = $(this).parent().find('.navigation__list--main').find('.navigation__list--second');
                    const firstLevel2 = $(this).parent().find('.navigation__item--first-level');

                    const subMenuHeight2 = subMenu2.outerHeight();
                    firstLevel2.css('height', subMenuHeight2 + 'px');

                    if ($firstLevel.length && subMenuHeight) {
                        $firstLevel.css('height', subMenuHeight);
                    }

                    return false;
                }
            }
        );

        defaults.initElem.on('click.mobileNav', '.navigation__link', function () {
            const $link = $(this);
            const $item = $link.parent();

            if (!$item.hasClass('navigation__item--has-dropdown')) {
                defaults.initElem
                    .find('.navigation__item--has-dropdown')
                    .removeData('activated');
            }
        });

        defaults.initElem.on('click.mobileNav', '.nav-toggle', function (e) {
            e.preventDefault();

            if (menu.curItem && menu.curItem.length) {
                safeMoveFocusOutOf(menu.curItem, $(this));
            } else {
                safeMoveFocusOutOf(defaults.initElem, $(this));
            }

            _updateActiveMenu(menu, 'back');
        });
    }

    function _updateActiveMenu(menu, direction) {
        if (direction === 'back') {
            if (!menu.curItem || !menu.curItem.length) {
                _slideMenu(menu, direction);
                _updateMenuTitle(menu);
                return;
            }

            const $closingItem = menu.curItem;

            _collapseItem($closingItem, defaults.initElem.find('.nav-toggle'));

            const $parentItem = $closingItem.parents('.navigation__item--has-dropdown').first();

            menu.curItem = $parentItem.length ? $parentItem : null;

            _slideMenu(menu, direction);

            if (menu.curItem && menu.curItem.length && menu.curLevel > 0) {
                menu.curItem.addClass('nav-dropdown-open nav-dropdown-active')
                    .data('activated', true);
            }

            _updateMenuTitle(menu);
        } else {
            if (!menu.curItem || !menu.curItem.length) {
                return;
            }

            menu.curItem
                .addClass('nav-dropdown-open nav-dropdown-active')
                .data('activated', true);

            _slideMenu(menu, direction);
            _updateMenuTitle(menu);
        }
    }

    function _updateMenuTitle(menu) {
        let title = defaults.menuTitle;

        if (menu.curLevel > 0 && menu.curItem && menu.curItem.length) {
            title = $.trim(menu.curItem.children('a').first().text());
            defaults.initElem.find('.nav-toggle').addClass('back-visible');
            defaults.initElem.addClass('navigation--upper-level');
        } else {
            defaults.initElem.find('.nav-toggle').removeClass('back-visible');
            defaults.initElem.removeClass('navigation--upper-level');

            $('.nav-toggle').css({
                transform: 'translateX(0%)'
            });
        }

        $('.nav-title').text(title);
    }

    function _slideMenu(menu, direction) {
        if ($(window).width() >= defaults.breakpoint) {
            return;
        }

        safeMoveFocusOutOf(defaults.initElem, defaults.initElem.find('.nav-toggle'));

        if (direction === 'back') {
            menu.curLevel = (menu.curLevel > 0) ? menu.curLevel - 1 : 0;
            menu.backLevel = (menu.curLevel > 0) ? menu.curLevel - 1 : 0;
        } else {
            menu.curLevel += 1;
            menu.backLevel = menu.curLevel - 1;
        }

        defaults.initElem.children('ul').css({
            transform: 'translateX(-' + (menu.curLevel * 100) + '%)'
        });

        $('.utility-block').css({
            transform: 'translateX(-' + (menu.curLevel * 100) + '%)'
        });

        $('.inner-right__search-box').css({
            transform: 'translateX(-' + (menu.curLevel * 100) + '%)'
        });

        $('.nav-toggle').css({
            transform: 'translateX(-' + (menu.backLevel * 100) + '%)'
        });
    }
}

function setupMobileNavigation() {
    const bodyWidth = $('body').outerWidth();

    if (bodyWidth < 1125) {
        if (mobileMenuInstance) {
            mobileMenuInstance.reset();
        }

        mobileMenuInstance = new MobileNav();

        $('.js-nav-toggle')
            .off('click.mobileNav')
            .on('click.mobileNav', (e) => {
                e.preventDefault();

                if ($('.nav-wrapper').hasClass('show-menu')) {
                    return;
                }

                if (mobileMenuInstance) {
                    mobileMenuInstance.reset();
                }

                $('.nav-wrapper').addClass('show-menu');
                $('.page-header').addClass('menu-active');

                document.body.style.position = 'fixed';
                document.body.style.top = `-${window.scrollY}px`;
            });

        $('.js-close-menu')
            .off('click.mobileNav')
            .on('click.mobileNav', (e) => {
                e.preventDefault();

                safeMoveFocusOutOf($('.navigation'), $('.js-nav-toggle'));

                if (mobileMenuInstance) {
                    mobileMenuInstance.reset();
                }

                $('.page-header').removeClass('menu-active');
                $('.nav-wrapper').removeClass('show-menu');

                document.body.style.position = '';
                document.body.style.top = '';
            });
    } else {
        $('.js-nav-toggle').off('click.mobileNav');
        $('.js-close-menu').off('click.mobileNav');

        $('.page-header').removeClass('menu-active');
        $('.nav-wrapper').removeClass('show-menu');

        document.body.style.position = '';
        document.body.style.top = '';

        if (mobileMenuInstance) {
            mobileMenuInstance.reset();
            mobileMenuInstance = null;
        }

        initHoverIntent();
    }
}

$(window).on('load resize', () => {
    setupMobileNavigation();
});

let hoverIntentActive = false;
let navCloseTimer = null;

function initHoverIntent() {
    if (hoverIntentActive) return;

    const nav = document.querySelector('.navigation');

    if (!nav) return;

    hoverIntentActive = true;

    const OPEN_DELAY = 250;
    const CLOSE_DELAY = 300;

    const rootList = nav.querySelector(':scope > .navigation__list');

    let currentHoverItem = null;
    let pendingOpenTimer = null;
    let pendingPlainItemTimer = null;
    let noChildGuardTimer = null;
    let lastPointerX = 0;
    let lastPointerY = 0;

    function isDesktopNav() {
        return window.matchMedia('(min-width: 1125px)').matches;
    }

    function getSubMenu(item) {
        return item.querySelector(':scope > .navigation__list');
    }

    function isTopLevelItem(item) {
        return rootList && item.parentElement === rootList;
    }

    function getMegaMenu(item) {
        let list = item.parentElement;

        while (list && list !== nav && list !== rootList) {
            if (
                list.classList &&
                list.classList.contains('navigation__list') &&
                list.querySelector(':scope > .navigation__item--has-block')
            ) {
                return list;
            }

            list = list.parentElement;
        }

        return null;
    }

    function getMegaMenuColumnItem(item) {
        const megaMenu = getMegaMenu(item);

        if (!megaMenu) return null;

        let current = item;

        while (current && current !== megaMenu && current !== nav) {
            if (
                current.parentElement === megaMenu &&
                current.classList &&
                current.classList.contains('navigation__item') &&
                !current.classList.contains('navigation__item--has-block')
            ) {
                return current;
            }

            current = current.parentElement;
        }

        return null;
    }

    function isMegaMenuColumnItem(item) {
        return getMegaMenuColumnItem(item) === item;
    }

    function isLeftColumnMenuItem(item) {
        const columnItem = getMegaMenuColumnItem(item);

        if (!columnItem) return false;

        const leftColumnList = getSubMenu(columnItem);

        return !!leftColumnList && item.parentElement === leftColumnList;
    }

    function isInsideMegaMenuBlock(item) {
        return !!item.closest('.navigation__item--has-block');
    }

    function updatePointerPosition(e) {
        lastPointerX = e.clientX;
        lastPointerY = e.clientY;
    }

    function getItemUnderPointer() {
        const element = document.elementFromPoint(lastPointerX, lastPointerY);

        if (!element || typeof element.closest !== 'function') {
            return null;
        }

        return element.closest('.navigation__item');
    }

    function clearPendingOpenTimer() {
        clearTimeout(pendingOpenTimer);
        pendingOpenTimer = null;
    }

    function clearPendingPlainItemTimer() {
        clearTimeout(pendingPlainItemTimer);
        pendingPlainItemTimer = null;
    }

    function clearNoChildGuardTimer() {
        clearTimeout(noChildGuardTimer);
        noChildGuardTimer = null;
    }

    function clearAllIntentTimers() {
        clearPendingOpenTimer();
        clearPendingPlainItemTimer();
        clearNoChildGuardTimer();
    }

    function clearTimers(item) {
        clearTimeout(item._openTimer);
        clearTimeout(item._closeTimer);
    }

    function setMegaMenuBlockEmpty(megaMenu, isEmpty) {
        if (!megaMenu) return;

        megaMenu
            .querySelectorAll('.navigation__item--has-block')
            .forEach((block) => {
                block.classList.toggle('navigation__item--block-hidden', isEmpty);
            });
    }

    function removeOpenClasses(item) {
        const subMenu = getSubMenu(item);

        item.classList.remove(
            'nav-dropdown-open',
            'nav-dropdown-active'
        );

        if (subMenu) {
            subMenu.classList.remove('navigation__list--show-menu');
        }

        item
            .querySelectorAll('.navigation__list--show-menu')
            .forEach((list) => {
                list.classList.remove('navigation__list--show-menu');
            });

        item
            .querySelectorAll('.navigation__item--block-hidden')
            .forEach((block) => {
                block.classList.remove('navigation__item--block-hidden');
            });
    }

    function closeItem(item) {
        clearTimers(item);
        removeOpenClasses(item);

        item
            .querySelectorAll('.navigation__item--has-dropdown')
            .forEach((child) => {
                clearTimers(child);
                removeOpenClasses(child);
            });
    }

    function closeSiblingTopLevelItems(item) {
        const siblings = item.parentElement?.querySelectorAll(
            ':scope > .navigation__item--has-dropdown'
        );

        if (!siblings) return;

        siblings.forEach((sibling) => {
            if (sibling !== item) {
                closeItem(sibling);
            }
        });
    }

    function clearChildMenusForMegaMenu(megaMenu) {
        if (!megaMenu) return;

        megaMenu
            .querySelectorAll('.navigation__item--has-dropdown')
            .forEach((dropdown) => {
                clearTimers(dropdown);

                if (isMegaMenuColumnItem(dropdown)) {
                    return;
                }

                dropdown.classList.remove(
                    'nav-dropdown-open',
                    'nav-dropdown-active'
                );

                const subMenu = getSubMenu(dropdown);

                if (subMenu) {
                    subMenu.classList.remove('navigation__list--show-menu');
                }
            });

        megaMenu
            .querySelectorAll('.navigation__list--show-menu')
            .forEach((list) => {
                if (list === megaMenu) {
                    return;
                }

                if (list.parentElement && isMegaMenuColumnItem(list.parentElement)) {
                    return;
                }

                list.classList.remove('navigation__list--show-menu');
            });

        megaMenu
            .querySelectorAll('.navigation__list--second')
            .forEach((list) => {
                list.classList.remove('navigation__list--show-menu');
            });
    }

    function openTopLevelItem(item) {
        const subMenu = getSubMenu(item);

        clearAllIntentTimers();
        closeSiblingTopLevelItems(item);

        item.classList.add(
            'nav-dropdown-open',
            'nav-dropdown-active'
        );

        if (subMenu) {
            subMenu.classList.add('navigation__list--show-menu');
            clearChildMenusForMegaMenu(subMenu);
            setMegaMenuBlockEmpty(subMenu, false);
        }
    }

    function openMegaMenuColumnItem(item) {
        const megaMenu = getMegaMenu(item);

        currentHoverItem = item;
        clearAllIntentTimers();
        clearChildMenusForMegaMenu(megaMenu);
        setMegaMenuBlockEmpty(megaMenu, false);
    }

    function openSecondLevelItem(item) {
        const megaMenu = getMegaMenu(item);
        const subMenu = getSubMenu(item);

        clearPendingPlainItemTimer();
        clearNoChildGuardTimer();

        clearChildMenusForMegaMenu(megaMenu);
        setMegaMenuBlockEmpty(megaMenu, true);

        item.classList.add(
            'nav-dropdown-open',
            'nav-dropdown-active'
        );

        if (subMenu) {
            subMenu.classList.add('navigation__list--show-menu');
        }
    }

    function openItem(item) {
        if (isTopLevelItem(item)) {
            openTopLevelItem(item);
            return;
        }

        if (isMegaMenuColumnItem(item)) {
            openMegaMenuColumnItem(item);
            return;
        }

        if (isLeftColumnMenuItem(item)) {
            openSecondLevelItem(item);
        }
    }

    function scheduleOpen(item) {
        clearPendingOpenTimer();
        clearPendingPlainItemTimer();
        clearNoChildGuardTimer();

        currentHoverItem = item;

        pendingOpenTimer = setTimeout(() => {
            const itemUnderPointer = getItemUnderPointer();

            if (
                currentHoverItem === item &&
                itemUnderPointer === item &&
                (item.matches(':hover') || item.querySelector(':hover'))
            ) {
                openItem(item);
            }
        }, OPEN_DELAY);
    }

    function scheduleClose(item) {
        clearTimeout(item._closeTimer);

        item._closeTimer = setTimeout(() => {
            if (
                !item.matches(':hover') &&
                !item.querySelector(':hover')
            ) {
                closeItem(item);
            }
        }, CLOSE_DELAY);
    }

    function closeWholeNavigation() {
        currentHoverItem = null;
        clearAllIntentTimers();

        nav
            .querySelectorAll('.navigation__item--has-dropdown')
            .forEach((item) => {
                closeItem(item);
            });

        nav
            .querySelectorAll('.navigation__item--block-hidden')
            .forEach((block) => {
                block.classList.remove('navigation__item--block-hidden');
            });
    }

    function forceEmptyIfStillOnPlainLeftColumnItem(item) {
        clearNoChildGuardTimer();

        noChildGuardTimer = setTimeout(() => {
            const itemUnderPointer = getItemUnderPointer();

            if (itemUnderPointer !== item) {
                return;
            }

            if (!isLeftColumnMenuItem(item)) {
                return;
            }

            if (item.classList.contains('navigation__item--has-dropdown')) {
                return;
            }

            const megaMenu = getMegaMenu(item);

            currentHoverItem = item;
            clearPendingOpenTimer();
            clearChildMenusForMegaMenu(megaMenu);
            setMegaMenuBlockEmpty(megaMenu, true);
        }, OPEN_DELAY + 80);
    }

    function schedulePlainLeftColumnItem(item) {
        currentHoverItem = item;

        clearPendingOpenTimer();
        clearPendingPlainItemTimer();
        clearNoChildGuardTimer();

        pendingPlainItemTimer = setTimeout(() => {
            const itemUnderPointer = getItemUnderPointer();

            if (
                currentHoverItem !== item ||
                itemUnderPointer !== item ||
                !isLeftColumnMenuItem(item) ||
                item.classList.contains('navigation__item--has-dropdown')
            ) {
                return;
            }

            const megaMenu = getMegaMenu(item);

            clearChildMenusForMegaMenu(megaMenu);
            setMegaMenuBlockEmpty(megaMenu, true);
            forceEmptyIfStillOnPlainLeftColumnItem(item);
        }, OPEN_DELAY);
    }

    function applyPlainLeftColumnItemImmediately(item) {
        const megaMenu = getMegaMenu(item);

        currentHoverItem = item;
        clearAllIntentTimers();
        clearChildMenusForMegaMenu(megaMenu);
        setMegaMenuBlockEmpty(megaMenu, true);
    }

    nav.addEventListener('mouseover', (e) => {
        if (!isDesktopNav()) return;

        updatePointerPosition(e);

        const item = e.target.closest('.navigation__item');

        if (!item || !nav.contains(item)) return;

        const previousItem = e.relatedTarget && typeof e.relatedTarget.closest === 'function'
            ? e.relatedTarget.closest('.navigation__item')
            : null;

        if (previousItem === item) {
            return;
        }

        clearTimeout(navCloseTimer);

        if (isInsideMegaMenuBlock(item)) {
            return;
        }

        if (isTopLevelItem(item)) {
            if (item.classList.contains('navigation__item--has-dropdown')) {
                scheduleOpen(item);
            }

            return;
        }

        if (isMegaMenuColumnItem(item)) {
            openMegaMenuColumnItem(item);
            return;
        }

        if (!isLeftColumnMenuItem(item)) {
            return;
        }

        if (item.classList.contains('navigation__item--has-dropdown')) {
            scheduleOpen(item);
            return;
        }

        schedulePlainLeftColumnItem(item);
    });

    nav.addEventListener('mousemove', (e) => {
        if (!isDesktopNav()) return;

        updatePointerPosition(e);
    });

    nav.addEventListener('mouseout', (e) => {
        if (!isDesktopNav()) return;

        const item = e.target.closest('.navigation__item--has-dropdown');

        if (!item || !nav.contains(item)) return;

        if (e.relatedTarget && item.contains(e.relatedTarget)) {
            return;
        }

        /*
            Do not close second-level items instantly. This provides the
            hover-out buffer for moving into the right-hand child panel.
        */
        if (!isTopLevelItem(item)) {
            return;
        }

        clearPendingOpenTimer();
        scheduleClose(item);
    });

    nav.addEventListener('mouseleave', () => {
        if (!isDesktopNav()) return;

        clearTimeout(navCloseTimer);
        currentHoverItem = null;
        clearAllIntentTimers();

        navCloseTimer = setTimeout(() => {
            closeWholeNavigation();
        }, CLOSE_DELAY);
    });

    nav.addEventListener('focusin', (e) => {
        if (!isDesktopNav()) return;

        const item = e.target.closest('.navigation__item');

        if (!item || !nav.contains(item)) return;

        clearTimeout(navCloseTimer);
        currentHoverItem = item;

        if (isInsideMegaMenuBlock(item)) {
            return;
        }

        if (isTopLevelItem(item)) {
            if (item.classList.contains('navigation__item--has-dropdown')) {
                openTopLevelItem(item);
            }

            return;
        }

        if (isMegaMenuColumnItem(item)) {
            openMegaMenuColumnItem(item);
            return;
        }

        if (!isLeftColumnMenuItem(item)) {
            return;
        }

        if (item.classList.contains('navigation__item--has-dropdown')) {
            openSecondLevelItem(item);
            return;
        }

        applyPlainLeftColumnItemImmediately(item);
    });

    nav.addEventListener('focusout', (e) => {
        if (!isDesktopNav()) return;

        const nextFocusedElement = e.relatedTarget;

        if (nextFocusedElement && nav.contains(nextFocusedElement)) {
            return;
        }

        clearTimeout(navCloseTimer);
        currentHoverItem = null;
        clearAllIntentTimers();

        navCloseTimer = setTimeout(() => {
            closeWholeNavigation();
        }, CLOSE_DELAY);
    });

    document.addEventListener('mouseover', (e) => {
        const li = e.target.closest('li.navigation__item--has-dropdown');
        if (!li) return;
        const sub = li.querySelector(':scope > ul');
        if (!sub) return;
        li.parentElement.querySelectorAll(':scope > li.navigation__item--has-dropdown').forEach((other) => {
            if (other === li) return;
            other.querySelector(':scope > a')?.setAttribute('aria-expanded', 'false');
            const u = other.querySelector(':scope > ul');
            if (u) { u.setAttribute('aria-hidden', 'true'); u.setAttribute('inert', ''); }
        });
        li.querySelector(':scope > a')?.setAttribute('aria-expanded', 'true');
        sub.setAttribute('aria-hidden', 'false');
        sub.removeAttribute('inert');
    }, true);
}
